const loadProductRecommendationsIntoSection = function () {
  const productRecommendationsSection = document.querySelector('.product-recommendations')

  if (productRecommendationsSection === null) {
    return
  }

  const productId = productRecommendationsSection.dataset.productId
  const baseUrl = productRecommendationsSection.dataset.baseUrl
  const limit = productRecommendationsSection.dataset.limit
  const sectionId = productRecommendationsSection.dataset.sectionId
  const requestUrl = baseUrl + '?section_id=' + sectionId + '&product_id=' + productId + '&limit=' + limit
  const request = new XMLHttpRequest()
  request.open('GET', requestUrl)
  request.onload = function () {
    if (request.status >= 200 && request.status < 300) {
      const container = document.createElement('div')
      container.innerHTML = request.response
      const containerRecommendations = container.querySelector('.product-recommendations')
      productRecommendationsSection.parentElement.innerHTML = containerRecommendations.innerHTML
    }
  }
  request.send()
}
document.addEventListener('shopify:section:load', function (event) {
  if (event.detail.sectionId === 'product-recommendations') {
    loadProductRecommendationsIntoSection()
  }
})

$(window).on('load', function () {
  loadProductRecommendationsIntoSection()
})
